<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="modal.show" :data="model" :title="model.uuid ? $t(`Update Note`) : $t(`Create New Note`)"
                   size="lg" @show="onShow" @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)"
                   :ok-title="$t('Submit')" :show-confirmation="showConfirmation" :is-loading="loading"
                   scrollable class="notes-modal">
      <div class="row">
        <div class="col-md-12">
          <input-widget type="ckeditor" :label="false" :model="model" attribute="description"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>
<script>
  import InputWidget from "../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal";
  import Note from "./Note.model";

  const {mapState, mapActions} = createNamespacedHelpers('notes');

  export default {
    name: "NoteModal",
    components: {InputWidget, ArtisioModal},
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new Note(),
      }
    },
    computed: {
      ...mapState({
        modal: state => state.modal,
        objectName: state => state.object_name,
        objectUuid: state => state.object_uuid,
        editObject: state => state.modal.object
      }),
    },
    watch: {
      editObject() {
        if (this.editObject && this.editObject.uuid) {
          this.model = new Note(this.editObject);
        }
      }
    },
    methods: {
      ...mapActions(['hideNoteModal', 'createNote', 'updateNote']),
      onShow() {
        this.showConfirmation = true
      },
      onHidden() {
        this.model = new Note();
        this.hideNoteModal();
      },
      async onSubmit() {
        let response;
        this.loading = true;
        this.model[`${this.objectName}_uuid`] = this.objectUuid;
        if (!this.model.uuid) {
          response = await this.createNote(this.model);
        } else {
          response = await this.updateNote(this.model);
        }
        this.loading = false;
        if (response.success) {
          this.showConfirmation = false;
          this.hideNoteModal();
          if (!this.model.uuid) {
            this.$toast('success', this.$t('Note was successfully created'));
          } else {
            this.$toast('success', this.$t('Note was successfully updated'));
          }
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  /deep/ .ck-editor__editable {
    min-height: 150px;
  }
</style>
